// ============================================
// AdWords Reklam Verme - Blog Content
// ============================================

import { BlogContent } from '../../types';

export const adwordsReklamVermeContent: BlogContent = {
  tableOfContents: [
    { id: "adwords-nedir", title: "AdWords Nedir?" },
    { id: "adwords-platform", title: "AdWords Platform Özellikleri" },
    { id: "google-ads-gecis", title: "Google Ads'e Geçiş Süreci" },
    { id: "farklar", title: "AdWords vs Google Ads Farkları" },
    { id: "gecis-rehberi", title: "Adım Adım Geçiş Rehberi" },
    { id: "2025-durum", title: "2025 Yılında AdWords" }
  ],
  content: [
    {
      type: "paragraph",
      value: "<strong>AdWords reklam verme</strong> dönemi sona erdi ve yerini <strong>Google Ads</strong> platformuna bıraktı. Hala eski <strong>Google AdWords</strong> arayüzünü veya terminolojiyi kullananlar için bu rehber, modern <strong>Google Ads platformuna</strong> geçiş sürecini ve iki platform arasındaki farkları detaylıca açıklıyor. <strong>Google AdWords'ten Google Ads'e geçiş</strong> sadece isim değişikliği değil, aynı zamanda önemli özellik ve arayüz güncellemeleri getirdi."
    },
    {
      type: "image",
      value: "/images/blog/adwords-google-ads-gecis.jpg",
      alt: "Google AdWords'ten Google Ads'e geçiş süreci ve platform karşılaştırması",
      caption: "AdWords'ten Google Ads'e evrimin hikayesi"
    },
    { type: "heading", value: "Google AdWords Nedir?", id: "adwords-nedir" },
    {
      type: "paragraph",
      value: "<strong>Google AdWords</strong>, 2000 yılında lansmanından 2018 yılına kadar kullanılan ismiyle Google'ın <strong>tıklama başına ödeme (PPC)</strong> reklam platformuydu. Platform, işletmelerin Google arama sonuçlarında, partner web sitelerinde ve daha sonra YouTube'da reklam göstermelerini sağlıyordu."
    },
    {
      type: "paragraph",
      value: "18 yıl boyunca <strong>AdWords</strong>, dijital reklamcılığın sektör standardı haline geldi. Ancak 2018'de Google, ürün portföyünü yeniden markalaştırma kararı aldı ve <strong>AdWords</strong> ismi <strong>Google Ads</strong> olarak değiştirildi."
    },
    {
      type: "subheading",
      value: "AdWords'ün Tarihi"
    },
    {
      type: "list",
      items: [
        "<strong>2000:</strong> Google AdWords lansmanı - 350 advertiser ile başladı",
        "<strong>2002:</strong> Cost-Per-Click (CPC) modeline geçiş",
        "<strong>2005:</strong> Display Network (içerik ağı) tanıtımı",
        "<strong>2008:</strong> YouTube reklamları entegrasyonu",
        "<strong>2010:</strong> Mobile advertising özellikleri",
        "<strong>2016:</strong> Expanded Text Ads formatı",
        "<strong>2018:</strong> Google Ads olarak yeniden markalandı"
      ]
    },
    { type: "heading", value: "AdWords Platform Özellikleri (2018 Öncesi)", id: "adwords-platform" },
    {
      type: "paragraph",
      value: "Eski <strong>Google AdWords platformu</strong> şu temel özelliklere sahipti:"
    },
    {
      type: "subheading",
      value: "Kampanya Türleri"
    },
    {
      type: "list",
      items: [
        "<strong>Search Network:</strong> Google arama sonuçlarında metin reklamları",
        "<strong>Display Network:</strong> Banner ve görsel reklamlar (2+ milyon site)",
        "<strong>Shopping:</strong> Ürün listeleme reklamları (e-ticaret için)",
        "<strong>Video:</strong> YouTube video reklamları",
        "<strong>App Campaigns:</strong> Mobil uygulama indirme kampanyaları"
      ]
    },
    {
      type: "subheading",
      value: "AdWords Editor"
    },
    {
      type: "paragraph",
      value: "<strong>AdWords Editor</strong>, kampanyaları çevrimdışı olarak yönetmek için masaüstü uygulamasıydı. Toplu değişiklikler yapmak için idealidi ve bugün hala <strong>Google Ads Editor</strong> olarak kullanılmaktadır."
    },
    {
      type: "subheading",
      value: "Quality Score Sistemi"
    },
    {
      type: "paragraph",
      value: "<strong>AdWords'ün Quality Score</strong> sistemi (1-10 arası), reklamın alakalılığını, beklenen tıklama oranını ve landing page deneyimini değerlendirirdi. Bu sistem Google Ads'te de devam etmektedir."
    },
    { type: "heading", value: "Google Ads'e Geçiş: 2018 Rebranding", id: "google-ads-gecis" },
    {
      type: "paragraph",
      value: "24 Temmuz 2018'de Google, <strong>AdWords'ü rebranding yaparak Google Ads'e dönüştürdü</strong>. Aynı zamanda:"
    },
    {
      type: "list",
      items: [
        "<strong>DoubleClick</strong> ve <strong>Google Analytics 360 Suite</strong>, <strong>Google Marketing Platform</strong> altında birleşti",
        "<strong>DoubleClick for Publishers</strong>, <strong>Google Ad Manager</strong> oldu",
        "<strong>AdWords API</strong>, <strong>Google Ads API</strong> adını aldı"
      ]
    },
    {
      type: "paragraph",
      value: "Bu değişiklik sadece kozmetik değildi. Google, platformu <strong>makine öğrenimi</strong> ve <strong>otomasyon</strong> odaklı olarak yeniden yapılandırdı."
    },
    { type: "heading", value: "AdWords vs Google Ads: Temel Farklar", id: "farklar" },
    {
      type: "paragraph",
      value: "İsim değişikliğinden çok daha fazlasıdır. İşte kritik farklar:"
    },
    {
      type: "table",
      headers: ["Özellik", "Google AdWords (2018 öncesi)", "Google Ads (2018 sonrası)"],
      rows: [
        ["<strong>Arayüz</strong>", "Klasik ve yeni arayüz seçeneği", "Sadece modern arayüz"],
        ["<strong>Kampanya Tipleri</strong>", "5 temel tip", "8+ tip (Smart, Performance Max eklendi)"],
        ["<strong>Reklam Formatı</strong>", "Expanded Text Ads (ETA)", "Responsive Search Ads (RSA) öncelikli"],
        ["<strong>Otomatik Teklifler</strong>", "Sınırlı", "Gelişmiş AI tabanlı stratejiler"],
        ["<strong>Responsive Ads</strong>", "Sınırlı", "Tüm kampanya tiplerinde mevcut"],
        ["<strong>Smart Campaigns</strong>", "Yok", "KOBİ'ler için basitleştirilmiş kampanyalar"],
        ["<strong>Performance Max</strong>", "Yok", "AI-powered çoklu kanal kampanyaları"],
        ["<strong>Raporlama</strong>", "Temel dashboard", "Gelişmiş insights ve öneriler"]
      ]
    },
    {
      type: "subheading",
      value: "Önemli Yenilikler"
    },
    {
      type: "list",
      items: [
        "<strong>Responsive Search Ads (RSA):</strong> 15 başlık + 4 açıklama, Google en iyi kombinasyonu seçer",
        "<strong>Smart Bidding:</strong> Target CPA, Target ROAS, Maximize Conversions stratejileri",
        "<strong>Audience Targeting:</strong> Gelişmiş demografik ve ilgi alanı hedefleme",
        "<strong>Performance Insights:</strong> Otomatik anomali tespiti ve öneriler",
        "<strong>Discovery Campaigns:</strong> YouTube, Gmail, Discover feed'de reklamlar",
        "<strong>Local Campaigns:</strong> Mağaza ziyaretlerini artırmak için özel kampanyalar"
      ]
    },
    { type: "heading", value: "Adım Adım Geçiş Rehberi", id: "gecis-rehberi" },
    {
      type: "paragraph",
      value: "Hala eski <strong>AdWords alışkanlıkları</strong> veya terminolojisi kullananlar için modern <strong>Google Ads'e</strong> geçiş rehberi:"
    },
    {
      type: "subheading",
      value: "1. Arayüz Alışkanlığı"
    },
    {
      type: "list",
      items: [
        "<strong>Eski:</strong> \"AdWords'de kampanya açıyorum\" → <strong>Yeni:</strong> \"Google Ads'te kampanya oluşturuyorum\"",
        "<strong>Navigasyon:</strong> Sol menü yapısı değişti, \"Kampanyalar\", \"Reklamlar ve Uzantılar\", \"Anahtar Kelimeler\" bölümleri yeniden organize edildi",
        "<strong>Arama:</strong> Üst kısımdaki arama çubuğu ile hızlıca bulmak istediğiniz öğeye ulaşabilirsiniz"
      ]
    },
    {
      type: "subheading",
      value: "2. Expanded Text Ads'den Responsive Search Ads'e Geçiş"
    },
    {
      type: "paragraph",
      value: "Haziran 2022'den itibaren <strong>Expanded Text Ads (ETA)</strong> oluşturulamıyor. <strong>Responsive Search Ads (RSA)</strong> zorunlu oldu:"
    },
    {
      type: "list",
      items: [
        "Mevcut ETA'larınız çalışmaya devam eder ancak yeni oluşturamazsınız",
        "RSA için 8-15 başlık ve 2-4 açıklama oluşturun",
        "Google, en iyi performans gösteren kombinasyonları otomatik seçer",
        "Ad Strength (Reklam Gücü) metriğini \"Excellent\" seviyesine getirin"
      ]
    },
    {
      type: "subheading",
      value: "3. Smart Bidding Stratejilerine Geçiş"
    },
    {
      type: "paragraph",
      value: "Manuel <strong>CPC (Cost-Per-Click)</strong> yerine otomatik teklif stratejileri kullanın:"
    },
    {
      type: "list",
      items: [
        "<strong>Target CPA:</strong> Belirli bir dönüşüm maliyeti hedefleyin",
        "<strong>Target ROAS:</strong> Reklam harcaması getirisi hedefi belirleyin",
        "<strong>Maximize Conversions:</strong> Bütçeniz dahilinde maksimum dönüşüm",
        "<strong>Maximize Conversion Value:</strong> En yüksek değerli dönüşümlere odaklan"
      ]
    },
    {
      type: "paragraph",
      value: "<strong>Not:</strong> Smart Bidding için en az 30 dönüşüm gereklidir (son 30 günde). Az verisi olanlar Manuel CPC ile başlayıp sonra geçebilir."
    },
    {
      type: "subheading",
      value: "4. Performance Max'i Keşfedin"
    },
    {
      type: "paragraph",
      value: "<strong>Performance Max</strong>, AdWords döneminde olmayan tamamen yeni bir kampanya türüdür:"
    },
    {
      type: "list",
      items: [
        "Tek kampanyada tüm Google kanallarına (Search, Display, YouTube, Gmail, Discover) erişim",
        "AI-powered otomatik optimizasyon",
        "Asset grupları oluşturarak (resim, video, metin) Google'ın kombinasyonlar yapmasını sağlayın",
        "E-ticaret ve lead generation için idealdir"
      ]
    },
    {
      type: "subheading",
      value: "5. Google Ads Editor'ü Güncelleyin"
    },
    {
      type: "paragraph",
      value: "<strong>AdWords Editor</strong> artık <strong>Google Ads Editor</strong> oldu. Son sürümü indirdiğinizden emin olun:"
    },
    {
      type: "list",
      items: [
        "Yeni kampanya tiplerini (Performance Max, Discovery) destekler",
        "RSA oluşturma ve yönetimi mevcut",
        "Toplu değişiklikler için hala en iyi araç",
        "<a href=\"https://ads.google.com/home/tools/google-ads-editor/\" target=\"_blank\" rel=\"nofollow\">Google Ads Editor indirme sayfası</a>"
      ]
    },
    { type: "heading", value: "2025 Yılında AdWords ve Google Ads", id: "2025-durum" },
    {
      type: "paragraph",
      value: "2025 yılı itibarıyla, <strong>AdWords terimi tamamen tarihe karıştı</strong>. Ancak bazı kullanıcılar hala alışkanlıkla \"AdWords\" diyebiliyor. İşte güncel durum:"
    },
    {
      type: "list",
      items: [
        "<strong>Adwords.google.com</strong> URL'si otomatik olarak <strong>ads.google.com</strong>'a yönlendiriliyor",
        "Tüm dokümantasyon ve yardım sayfaları \"Google Ads\" terminolojisi kullanıyor",
        "Klasik AdWords arayüzü artık hiç erişilebilir değil",
        "API'ler tamamen Google Ads API'ye geçti (AdWords API deprecated)",
        "Sertifikalar \"Google Ads\" ismi altında veriliyor"
      ]
    },
    {
      type: "subheading",
      value: "Gelecek Trendler"
    },
    {
      type: "paragraph",
      value: "<strong>Google Ads platformu</strong> sürekli evrim geçiriyor. 2025-2026'da beklenen yenilikler:"
    },
    {
      type: "list",
      items: [
        "<strong>AI-First Approach:</strong> Daha fazla otomasyon, daha az manuel kontrol",
        "<strong>Privacy-Focused:</strong> Cookie'siz tracking çözümleri (Google Analytics 4 entegrasyonu)",
        "<strong>Video-First:</strong> YouTube Shorts ve kısa video formatların önemi artıyor",
        "<strong>Conversational AI:</strong> Chatbot benzeri kampanya oluşturma asistanları",
        "<strong>Predictive Analytics:</strong> Yapay zekanın öngörücü önerileri"
      ]
    },
    {
      type: "paragraph",
      value: "<strong>AdWords reklam verme</strong> dönemi sona erdi ama temel prensipler aynı kaldı: doğru kişiye, doğru zamanda, doğru mesajı iletmek. <strong>Google Ads</strong> bu prensibi daha gelişmiş araçlarla sunuyor. Eğer hala eski terminoloji veya yöntemler kullanıyorsanız, zamanı geldi modernleşmeye. Detaylı Google Ads eğitimi için <a href=\"https://skillshop.withgoogle.com\" target=\"_blank\" rel=\"nofollow\">Google Skillshop</a>'u ziyaret edebilir veya profesyonel bir <a href=\"/blog/google-ads-uzmani\" class=\"text-[#059669] font-bold hover:underline\">Google Ads uzmanı</a> ile çalışabilirsiniz."
    }
  ]
};

export default adwordsReklamVermeContent;
